import { render } from "./Descontos.vue?vue&type=template&id=e14df3d8&scoped=true"
import script from "./Descontos.vue?vue&type=script&lang=js"
export * from "./Descontos.vue?vue&type=script&lang=js"

import "./Descontos.vue?vue&type=style&index=0&id=e14df3d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e14df3d8"]])

export default __exports__